import angular from 'angular';
import './formEditor.scss';

import cmsCreatorFormInputText from './../SectionsLibrary/Sections/Form/TextInput/textInput';
import cmsCreatorFormInputEmail from './../SectionsLibrary/Sections/Form/EmailInput/emailInput';
import cmsCreatorFormInputDate from './../SectionsLibrary/Sections/Form/DateInput/dateInput';
import cmsCreatorFormInputDateTime from './../SectionsLibrary/Sections/Form/DateTimeInput/dateTimeInput';
import cmsCreatorFormInputNumber from './../SectionsLibrary/Sections/Form/NumberInput/numberInput';
import cmsCreatorFormInputRadio from './../SectionsLibrary/Sections/Form/RadioInput/radioInput';
import cmsCreatorFormInputSelect from './../SectionsLibrary/Sections/Form/SelectInput/selectInput';
import cmsCreatorFormInputTextarea from './../SectionsLibrary/Sections/Form/TextareaInput/textareaInput';
import cmsCreatorFormInputCheckbox from './../SectionsLibrary/Sections/Form/CheckboxInput/checkboxInput';
import cmsCreatorFormInputPlainText from './../SectionsLibrary/Sections/Form/PlainTextInput/plainTextInput';
import cmsCreatorFormInputSubmit from './../SectionsLibrary/Sections/Form/SumbitInput/submitInput';
import cmsCreatorFormInputCaptcha from './../SectionsLibrary/Sections/Form/CaptchaInput/captchaInput';

const creatorFormEditor = {
    bindings: {
        elementModel: '<'
    },
    template: require('./formEditor.html')
};

export default angular.module('cms.creator.form.editor', [
    cmsCreatorFormInputText,
    cmsCreatorFormInputEmail,
    cmsCreatorFormInputDate,
    cmsCreatorFormInputDateTime,
    cmsCreatorFormInputNumber,
    cmsCreatorFormInputRadio,
    cmsCreatorFormInputSelect,
    cmsCreatorFormInputTextarea,
    cmsCreatorFormInputCheckbox,
    cmsCreatorFormInputPlainText,
    cmsCreatorFormInputSubmit,
    cmsCreatorFormInputCaptcha
]).component('cmsCreatorFormEditor', creatorFormEditor).name



// WEBPACK FOOTER //
// ./src/cmsCore/Creator/FormEditor/FormEditor.js